import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import ModalBox from '../../ui-core/Modal';
import { deleteCommunityAccountRequest } from '../../api/community';
import { doLogoutRequest } from '../../store/action/auth';
import {
  createNotification,
  NOTIFICATION_TYPE,
} from '../../services/Notification';
import { errorHandler } from '../../utils/helpers';
import './style.css';

const DeleteAccount = ({ handleClose, show, userId }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleDelete = async () => {
    setLoading(true);
    try {
      await deleteCommunityAccountRequest();
      createNotification({
        type: NOTIFICATION_TYPE.SUCCESS,
        message: 'Your account has been deleted.',
      });
      handleClose();
      dispatch(doLogoutRequest());
    } catch (error) {
      createNotification(errorHandler(error));
      setLoading(false);
    }
  };

  return (
    <ModalBox
      show={show}
      handleClose={handleClose}
      dialogClassName="delete-account-modal modal-dialog-centered"
      head="Delete Account"
    >
      <div className="delete-account-modal-body">
        <br />
        <p className="delete-account-modal-text">
          Are you sure you want to delete your account? This action cannot be
          undone, and all your data will be permanently removed.
        </p>
        <div className="delete-account-modal-actions">
          <button
            type="button"
            className="delete-account-modal-btn delete-account-modal-btn--outline"
            onClick={handleDelete}
            disabled={loading}
          >
            {loading ? (
              <Spinner animation="border" size="sm" role="status" />
            ) : (
              'Delete'
            )}
          </button>
          <button
            type="button"
            className="delete-account-modal-btn delete-account-modal-btn--filled"
            onClick={handleClose}
            disabled={loading}
          >
            Cancel
          </button>
        </div>
      </div>
    </ModalBox>
  );
};

DeleteAccount.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default DeleteAccount;
